import { formatNumber } from "helpers/utility/formatters";

export function getProgressText(value: number, min: number): string {
  if (value < min)
    return `Pick ${formatNumber(min - value)} more to meet minimum`;
  if (value === min) return "Minimum reached!";
  return "Pick more to improve results";
}
export function getFillPercent(
  value: number,
  min: number,
  milestonePercent: number,
  maxFill = 95,
  logMaxValue = 3000,
): number {
  const log = (v: number) => Math.log(v + 1);

  if (min <= 0) {
    const logValue = log(value);
    const logMax = log(logMaxValue);
    const scaled = logValue / logMax;
    return Math.min(scaled * maxFill, maxFill);
  }

  // value < min
  if (value < min) {
    return (value / min) * milestonePercent;
  }

  // value === min
  if (value === min) {
    return milestonePercent;
  }

  const logMin = log(min);
  const logValue = log(value);
  const logMax = log(logMaxValue);

  const scaled = (logValue - logMin) / (logMax - logMin);
  return Math.min(
    milestonePercent + scaled * (maxFill - milestonePercent),
    maxFill,
  );
}

export const getStrokeColor = (value: number, min: number) => {
  if (!value || !min) {
    return { from: "#00B2FF", to: "#32E0C4" };
  }
  return value < min ? "#ff4d4f" : { from: "#00B2FF", to: "#32E0C4" };
};
